// extracted by mini-css-extract-plugin
export default {"form":"Form_form__Jl6hT","button":"Form_button__KdV7+"};